import styled from '@emotion/styled';

export const TypographyDiv = styled.div`
  position: relative;
  top: 6px;
`;
